var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45 30C3.45 15.337 15.336 3.45 30 3.45c14.663 0 26.55 11.887 26.55 26.55S44.662 56.55 30 56.55C15.336 56.55 3.45 44.663 3.45 30z",
    fill: "#5FC375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.884 29.5l7.744 7.744 15.487-15.488",
    stroke: "#fff",
    strokeWidth: 3.688
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTkiIGhlaWdodD0iNTkiIHZpZXdCb3g9IjAgMCA1OSA1OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuNDQ5NzEgMjkuOTk5N0MzLjQ0OTcxIDE1LjMzNjYgMTUuMzM2NSAzLjQ0OTgzIDI5Ljk5OTYgMy40NDk4M0M0NC42NjI2IDMuNDQ5ODMgNTYuNTQ5NCAxNS4zMzY2IDU2LjU0OTQgMjkuOTk5N0M1Ni41NDk0IDQ0LjY2MjggNDQuNjYyNiA1Ni41NDk1IDI5Ljk5OTYgNTYuNTQ5NUMxNS4zMzY1IDU2LjU0OTUgMy40NDk3MSA0NC42NjI4IDMuNDQ5NzEgMjkuOTk5N1oiIGZpbGw9IiM1RkMzNzUiLz4KPHBhdGggZD0iTTE3Ljg4NDMgMjkuNDk5OUwyNS42MjggMzcuMjQzNkw0MS4xMTU0IDIxLjc1NjIiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMy42ODc1Ii8+Cjwvc3ZnPgo=";
export { SvgDone as ReactComponent };